<template>
<!--  <vue-markdown>{{title}}</vue-markdown>-->
  <vue-markdown :postrender="markdownRendered">{{title}}</vue-markdown>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: "MacroTitle",
  data () {
    return {

    }
  },
  components: {
    VueMarkdown
  },

  methods: {
    markdownRendered (output) {

      const regex = new RegExp('<[^>]+>');
      const matches = regex.exec(output);

      if (matches) {
        let tagOpening = matches[0].replace('>', ' class=\"'+ this.addClass +'\">')

        const transformedOutput = output.replace(matches[0], tagOpening)

        return transformedOutput
      }

    }
  },

  props: {
    title: String,
    addClass: String
  }
}
</script>
